import "./sections/homepage/homepage.css";

import { Outlet } from "react-router-dom";

import { Header } from "./components/header";
import { Footer } from "./sections/homepage/footer";

export const HomeLayout = () => (
  <div className="min-h-screen bg-[#f7f3e9] text-[#17233f]">
    <Header />
    <Outlet />
  </div>
);

// Shared chrome for the homepage and solution pages. Other public routes keep their layouts.
export const MarketingLayout = () => (
  <div className="marketing-page">
    <Outlet />
    <Footer />
  </div>
);
